<!-- ================管理端-协同备课研讨====================-->
<template>
    <div class="discuss-container">
        <div class="discuss-body">
            <!-- 左侧缩略图 -->
            <div class="left-box">
                <el-card style="height: calc(100vh - 5px);overflow-y: auto;">
                    <div v-if="bookData.imgUrl">
                        <div @click="changeCurrent(index)" class="swbox"
                             v-for="(item, index) in bookData.pages" :key="index" style="position: relative;">
                            <img :src="bookData.imgUrl + '/' + (index + 1) + '.png'" alt=""
                                 :style="`width: 150px;height: ${bookData.fileHeight / bookData.fileWidth * 150}px;border-radius: 10px;border: 1px solid ${current == index ? '#377f7f' : '#eee'};`">
                            <div class="page-num-box">{{ index + 1 }}</div>
                        </div>
                    </div>
                    <el-empty v-else description="暂无文件" />
                </el-card>
            </div>

            <!-- 中间文件预览 -->
            <div class="mid-box">
                <el-card style="height: calc(100vh - 5px);">
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div style="display: flex;">
                            <div><span style="font-weight: bold;">备课标题：</span>{{ form.title || '--' }}</div>
                            <div style="padding-left: 30px;"><span style="font-weight: bold;">主备人：</span>{{ form.leadUserName || '--' }}</div>
                        </div>
                    </div>
                    <div style="padding: 15px 0;display: flex;width: 100%">
                        <el-row style="width: 100%">
                            <el-col :span="10">
                                <el-radio-group v-if="form.status != 4" @change="changeLessonType" v-model="lessonType" size="large">
                                    <el-radio-button v-show="form.jaFiles && form.jaFiles.length != 0" label="教案" />
                                    <el-radio-button v-show="form.xaFiles && form.xaFiles.length != 0" label="学案" />
                                    <el-radio-button v-show="form.kjFiles && form.kjFiles.length != 0" label="课件" />
                                    <el-radio-button v-show="form.xtFiles && form.xtFiles.length != 0" label="习题" />
                                </el-radio-group>
                                <el-radio-group v-if="form.status == 4" @change="changeLessonType" v-model="lessonType" size="large">
                                    <el-radio-button v-show="form.ytjaFiles && form.ytjaFiles.length != 0" label="教案" />
                                    <el-radio-button v-show="form.ytxaFiles && form.ytxaFiles.length != 0" label="学案" />
                                    <el-radio-button v-show="form.ytkjFiles && form.ytkjFiles.length != 0" label="课件" />
                                    <el-radio-button v-show="form.ytxtFiles && form.ytxtFiles.length != 0" label="习题" />
                                </el-radio-group>
                            </el-col>
                            <el-col :span="14">
                                <el-select style="width: 90%;margin-left: 10px" @change="changeFile" v-model="fileId" placeholder="请选择文件" size="large">
                                    <el-option v-for="item in fileList" :key="item.fileId" :label="item.fileName" :value="item.fileId" />
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>
                    <div ref="bjcan" id="bjcan" :style="`height: calc(100vh - 150px);overflow-y: auto;padding-bottom: 15px;`">
                        <div v-if="bookData.imgUrl"
                             :style="`width: ${zdyWidth}px;position: relative;height:${bookData.fileHeight / bookData.fileWidth * zdyWidth}px`">
                            <img :width="zdyWidth" :src="bookData.imgUrl + '/' + (current + 1) + '.png'" alt=""
                                 style="border: 1px solid #eeeeee;border-radius: 10px;position: absolute;">
                        </div>
                        <el-empty v-else description="暂无文件预览" />
                    </div>
                </el-card>
            </div>

            <!-- 右侧研讨 -->
            <div class="right-box">
                <div class="discuss-title-box">协同备课研讨</div>
                <div class="discuss-sub-box">
                    <div class="discuss-info">
                        <el-input type="textarea" resize="none" placeholder="请输入研讨内容" v-model="discussWordContent"
                                  class="discuss-info-input" />
                    </div>
                    <div class="discuss-btn-box">
                        <div class="limit">
                            <el-upload class="avatar-uploader" :action="serviceUrl+'/businessservice/discuss/uploadAnnex'"
                                       :show-file-list="false" :on-success="handleUploadFileSuccess" :headers="{ token }"
                                       accept=".doc,.docx,.ppt,.pptx,.pdf" :before-upload="beforeFileUpload">
                                <img class="icon-upload-img" alt="上传附件" src="../../../assets/image/upload_file1.png">
                            </el-upload>
                        </div>
                        <div class="limit">
                            <el-upload class="avatar-uploader" :action="serviceUrl+'/businessservice/discuss/uploadAnnex'"
                                       :show-file-list="false" :on-success="handleUploadImageSuccess" :headers="{ token }"
                                       accept=".png,.jpeg,.jpg" :before-upload="beforeImageUpload">
                                <img class="icon-upload-img" alt="上传图片" src="../../../assets/image/upload_img1.png">
                            </el-upload>
                        </div>
                        <el-button type="primary" style="margin-left: 10px;" round @click="submit">发表研讨</el-button>
                    </div>
                </div>
                <el-scrollbar class="discuss-show-box">
                    <div class="discuss-one" v-for="item in discussList" :key="item.discussId">
                        <div class="discuss-user-avatar">
                            <img alt="" @error="onImageError" :src="item.avatar">
                        </div>
                        <div class="discuss-user-content">
                            <div class="user-info">
                                <div class="flex-item user-true-name">{{item.createUserName}}</div>
                                <div class="flex-item user-role">
                                    <div class="role1" v-show="item.roleType===3">专家</div>
                                    <div class="role2" v-show="item.roleType===0">主备人</div>
                                    <div class="role2" v-show="item.roleType===1">协备人</div>
                                </div>
                                <div class="flex-item content-time">{{timestampToTime(item.createTime)}}</div>
                            </div>
                            <div class="content-info" v-if="item.discussType===1">{{item.content}}</div>
                            <div class="img-info" v-if="item.discussType===2">
                                <el-image alt="" :src="item.imgContent" :preview-src-list="[item.imgContent]" />
                            </div>
                            <div class="audio-info" v-if="item.discussType===3">
                                <audio controls controlslist="nodownload noplaybackrate">
                                    <source type="audio/mpeg" :src="item.audioContent" />
                                </audio>
                            </div>
                            <div class="file-info" v-if="item.discussType===4">
                                <div class="file-box">
                                    <div class="file-icon">
                                        <el-image @click="handleFileStatus(item.file.status)" class="icon-image" v-if="comStr('pdf',item.file.fileType) || comStr('doc',item.file.fileType) || comStr('ppt',item.file.fileType)"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                        <el-image @click="handleUnknow" class="icon-image" v-else
                                                  :src="require('@/assets/file/file_view_color.png')">
                                        </el-image>
                                    </div>
                                    <div class="file-detail">
                                        <div class="name-box" @click.stop="handleDownload(item.file.fileUrl,item.file.fileName)">{{item.file.fileName}}</div>
                                        <div class="size-box">
                                            <div class="size-num">{{item.file.fileSize}}</div>
                                            <div class="file-view">
                                                <img alt="" src="@/assets/file/file_download.png" @click.stop="handleDownload(item.file.fileUrl,item.file.fileName)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="discussList && discussList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../../assets/image/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import { lessonInfo, discussCreate, discussDel, discussList } from "@/api/admin/lesson";
import { timestampToTime } from "@/utils/date";
import { downloadFile } from "@/utils/download";
import { ElLoading } from 'element-plus'
import { serviceUrl } from "@/utils/global"

export default {
    name: "teamLessonDiscuss",
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            discussWordContent: '',
            userId: JSON.parse(this.$storage.get("userInfo")).userId,
            lessonId: '',
            lessonType: '',
            current: 0,
            timestampToTime,
            bookData: {},
            fileId: '',
            fileList: [],
            form: {
                jaFiles: [],
                xaFiles: [],
                kjFiles: [],
                xtFiles: [],
                ytjaFiles: [],
                ytxaFiles: [],
                ytkjFiles: [],
                ytxtFiles: [],
            },
            zdyWidth: 0,
            discussList: [],
            discussType: 1,
            wordContent: '',
            imgContent: '',
            fileContent: '',
        };
    },
    created() {},
    mounted() {
        this.lessonId = this.$route.query.lessonId
        this.$nextTick(() => {
            this.zdyWidth = (document.getElementById("bjcan").clientWidth - 20)
            this.getDetail()
        })
    },
    methods: {
        submit() {
            const obj = {
                pageNum: this.current,
                fileId: this.fileId,
                content: this.wordContent,
                imgContent: this.imgContent,
                fileContent: this.fileContent,
            };
            if (this.discussType === 1) {
                this.wordContent = this.discussWordContent
                if (this.wordContent === '') {
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content = this.wordContent;
                obj.imgContent = '';
                obj.fileContent = ''
            }
            if (this.discussType === 2) {
                if (this.imgContent === '') {
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content = '';
                obj.imgContent = this.imgContent;
                obj.fileContent = ''
            }
            if (this.discussType === 4) {
                if (this.fileContent === '') {
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content = '';
                obj.imgContent = '';
                obj.fileContent = this.fileContent
            }
            const loading = ElLoading.service({ fullscreen: true })
            discussCreate(obj).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("发表成功");
                    this.wordContent = ''
                    this.discussWordContent = ''
                    this.imgContent = ''
                    this.fileContent = ''
                    this.discussType = 1
                    this.getDisList();
                    loading.close()
                } else {
                    this.$message.error(res.data.msg || "发表失败")
                    this.discussType = 1
                    loading.close()
                }
            })
        },
        getDisList() {
            if (!this.fileId) {
                this.discussList = [];
                return;
            }
            discussList({ fileId: this.fileId, pageNum: this.current }).then(res => {
                this.discussList = res.data.data || [];
            })
        },
        changeLessonType() {
            const status = this.form.status;
            const typeMap = {
                '教案': status == 4 ? 'ytjaFiles' : 'jaFiles',
                '学案': status == 4 ? 'ytxaFiles' : 'xaFiles',
                '课件': status == 4 ? 'ytkjFiles' : 'kjFiles',
                '习题': status == 4 ? 'ytxtFiles' : 'xtFiles',
            };
            const field = typeMap[this.lessonType];
            this.fileList = this.form[field] || [];
            if (this.fileList.length != 0) {
                this.fileId = this.fileList[0].fileId
                this.bookData = this.fileList[0]
            } else {
                this.fileId = ''
                this.bookData = {}
            }
            this.current = 0;
            this.getDisList();
        },
        changeFile() {
            this.fileList.forEach(j => {
                if (j.fileId == this.fileId) {
                    this.bookData = j;
                }
            })
            this.current = 0;
            this.getDisList();
        },
        changeCurrent(index) {
            this.current = index;
            this.getDisList();
        },
        getDetail() {
            lessonInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data.code === 1) {
                    const data = res.data.data || {};
                    const textList = [];
                    (data.teamUserList || []).forEach(j => {
                        textList.push(j.trueName || j.expertName || '')
                    })
                    data.teamUserText = textList.join('、')
                    this.form = data;
                    this.initFile();
                    this.current = 0;
                    this.getDisList();
                }
            })
        },
        initFile() {
            const fields = ['jaFiles', 'xaFiles', 'kjFiles', 'xtFiles', 'ytjaFiles', 'ytxaFiles', 'ytkjFiles', 'ytxtFiles'];
            fields.forEach(field => {
                this.form[field] = this.form[field] || [];
            });
            const status = this.form.status;
            const order = status == 4
                ? [['教案', 'ytjaFiles'], ['学案', 'ytxaFiles'], ['课件', 'ytkjFiles'], ['习题', 'ytxtFiles']]
                : [['教案', 'jaFiles'], ['学案', 'xaFiles'], ['课件', 'kjFiles'], ['习题', 'xtFiles']];
            let selected = false;
            for (const [label, field] of order) {
                if (this.form[field].length !== 0) {
                    this.lessonType = label;
                    this.fileList = this.form[field];
                    this.bookData = this.form[field][0];
                    this.fileId = this.form[field][0].fileId;
                    selected = true;
                    break;
                }
            }
            if (!selected) {
                this.lessonType = '';
                this.fileList = [];
                this.bookData = {};
                this.fileId = '';
            }
        },
        onImageError(event) {
            event.target.src = 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/load_fail_default.png';
        },
        handleUploadImageSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.imgContent = uploadFile.response.data;
                this.discussType = 2
                this.submit()
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeImageUpload(rawFile) {
            if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleUploadFileSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.fileContent = uploadFile.response.data;
                this.discussType = 4
                this.submit()
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeFileUpload() {
            return true
        },
        comStr(baseStr, type) {
            return type !== '' && type.toUpperCase().includes(baseStr.toUpperCase());
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
        handleDownload(url, fileName) {
            downloadFile(url, fileName)
        },
        handleUnknow() {
            this.$message.info("该文件类型暂不支持预览")
        },
        handleFileStatus(status) {
            if (status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        deleteDiscuss(item) {
            discussDel({ discussId: item.discussId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success('删除成功')
                    this.getDisList()
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
    }
};
</script>
<style scoped>
.discuss-container {
    padding: 0;
    overflow-y: hidden;
}
.discuss-body {
    height: calc(100vh - 10px);
    display: flex;
    overflow-y: hidden;
}
.left-box {
    padding: 15px 0 15px 0;
    width: 190px;
    height: 100%;
    margin-right: 10px;
}
.mid-box {
    padding: 15px 0 15px 0;
    flex: 1;
}
.right-box {
    padding: 15px 5px 15px 0px;
    width: 300px;
    height: 100%;
    margin-left: 10px;
}
.discuss-title-box {
    margin-bottom: 10px;
    height: 20px;
    font-weight: bold;
    color: #377f7f;
}
.discuss-sub-box {
    width: 100%;
    background-color: rgba(245, 246, 247, 0.9);
    border-radius: 8px;
    margin-top: 5px;
    padding-bottom: 10px;
    height: auto;
}
.discuss-info {
    display: inline-block;
    width: 100%;
}
.discuss-info-input /deep/ .el-textarea__inner {
    font-size: 12px;
}
.discuss-btn-box {
    display: flex;
    padding: 0 6px;
    margin-top: 10px;
    align-items: center;
}
.discuss-btn-box .el-button--primary {
    width: auto;
    height: 26px;
    font-size: 12px;
    line-height: 26px !important;
    text-align: center;
}
.limit {
    width: 26px;
    height: 26px;
    background-color: #377f7f;
    font-size: 12px;
    color: #999aaa;
    border-radius: 13px;
    margin-right: 10px;
}
.icon-upload-img {
    width: 20px;
    height: 20px;
    margin: 3px 0 0 3px;
}
.discuss-show-box {
    width: 300px !important;
    margin: auto;
    height: calc(100vh - 190px) !important;
}
.discuss-one {
    display: flex;
    margin-bottom: 10px;
}
.discuss-user-avatar {
    width: 40px;
}
.discuss-user-avatar img {
    width: 30px !important;
    height: 30px;
    border-radius: 15px !important;
}
.discuss-user-content {
    width: 260px;
    font-size: 14px;
}
.user-info {
    display: flex;
    height: 25px;
    padding-right: 10px;
    align-items: center;
}
.user-info .flex-item:last-child {
    margin-left: auto;
}
.user-true-name {
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    text-align: left;
    margin-right: 10px;
}
.user-role {
    font-size: 10px;
}
.user-role div {
    text-align: center;
}
.role1 {
    padding: 1px 4px;
    background-color: #377f7f;
    margin-top: 4px;
    border-radius: 4px;
    color: #FFFFFF;
}
.role2 {
    padding: 1px 4px;
    background-color: #f1f1f1;
    margin-top: 4px;
    border-radius: 4px;
    color: #666666;
}
.content-time {
    line-height: 25px;
    font-size: 12px;
}
.content-info {
    padding: 2px 10px 0 0;
    font-size: 12px;
    color: #525B68;
    line-height: 18px;
    word-wrap: break-word;
    word-break: break-all;
}
.img-info {
    padding: 2px 10px 0 0;
    display: flex;
    width: 180px;
    flex-wrap: wrap;
}
.img-info .el-image {
    width: 120px;
    height: auto;
    margin: 0 5px 5px 0;
}
.audio-info {
    padding: 2px 10px 0 0;
}
.audio-info audio {
    width: 210px;
    height: 40px;
}
.file-info {
    padding: 2px 10px 0 0;
}
.file-box {
    width: 240px;
    height: 44px;
    background-color: #f1f3f4;
    border-radius: 5px;
    display: flex;
}
.file-icon {
    width: 40px;
    height: 40px;
}
.file-icon .icon-image {
    width: 24px;
    height: 30px;
    margin-top: 6px;
    margin-left: 6px;
}
.file-detail {
    width: 190px;
    height: 40px;
    padding: 2px 0;
}
.file-detail div {
    width: 190px;
    height: 20px;
}
.name-box {
    line-height: 24px;
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.name-box:hover {
    color: #377f7f;
}
.size-box {
    display: flex;
    font-size: 10px;
    line-height: 20px;
}
.file-view {
    width: 15px;
    height: 15px;
    margin-top: 5px;
    margin-left: 5px;
}
.file-view img {
    width: 13px;
    height: 13px;
    margin: 1px 0 0 0;
    cursor: pointer;
}
.data-empty {
    width: 100px;
    height: 100px;
    margin: 20px auto;
    text-align: center;
}
.empty-icon {
    width: 100px;
    height: 40px;
}
.empty-icon img {
    width: 40px;
    height: 40px;
}
.empty-title {
    width: 100px;
    font-size: 12px;
    text-align: center;
    color: #999999;
}
.swbox {
    margin-bottom: 10px;
    flex: 1;
    cursor: pointer;
}
.page-num-box {
    text-align: center;
    padding: 5px 0 0 0;
    font-size: 12px;
}
#bjcan {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
</style>
